
export default function GeneratePOPDF_SVG() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.88331 8.53334H6.49997V7.15H7.53331L7.91664 6.75V5.5L7.53331 5.11667H5.88331V8.53334ZM6.49997 6.53334V5.73334H7.29997V6.53334H6.49997ZM8.53331 8.53334H10.1666L10.55 8.13334V5.5L10.1666 5.11667H8.53331V8.53334ZM9.14997 7.91667V5.73334H9.93331V7.91667H9.14997ZM11.3 8.53334H11.9166V7.15H12.75V6.53334H11.9166V5.73334H12.75V5.11667H11.3V8.53334ZM3.19997 12.8V0.616669H15.3833V12.8H3.19997ZM4.76664 11.2333H13.8V2.2H4.76664V11.2333ZM0.616638 15.3833V3.2H2.19997V13.8H12.8V15.3833H0.616638Z" fill="#172128"/>
    </svg>

  )
}

